import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";

/** Compact spinner for page content — keeps header/sidebar mounted. */
export function RouteLoadingFallback() {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flex={1}
      minHeight="40vh"
      width="100%"
    >
      <CircularProgress size={32} sx={{ color: "var(--primary-600)" }} />
    </Box>
  );
}

/** Nest under a layout route so only `<Outlet />` suspends, not the shell. */
export function SuspenseOutlet() {
  return (
    <Suspense fallback={<RouteLoadingFallback />}>
      <Outlet />
    </Suspense>
  );
}

export function LazyRoute({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<RouteLoadingFallback />}>{children}</Suspense>;
}
